import React from "react";
import { Link } from "react-router-dom";

import './AccountCard.css';

export default function AccountCard({account, accountId}) {

    return (
        <Link to={`../account/${accountId}`}>
            <div className="account-card">
                <h2>{account.accountType}</h2>
                <h3 className="balance">${account.balance.toFixed(2)}</h3>
            </div>
        </Link>
    )
}